import type { Shell } from '#packages/apilib';
import { AiHtmlPromptApiKey } from '../aiHtmlPromptApi/publicApiKey';
import type { AiHtmlGenerationPromptParams } from '../aiHtmlPromptApi/types';
import { aiHtmlSectionActions, type AiHtmlSectionState } from '../state';
import type { AiHtmlSectionUIApi } from './types';

export function createAiHtmlSectionUIApi(shell: Shell): AiHtmlSectionUIApi {
  const { dispatch, getState } = shell.getStore<{
    aiHtmlSection: AiHtmlSectionState;
  }>();
  const aiHtmlPromptApi = shell.getAPI(AiHtmlPromptApiKey);

  const handleAiHtmlFormSubmit = async (
    params: AiHtmlGenerationPromptParams,
  ) => {
    const { setIsLoading, setGeneratedSection } = aiHtmlSectionActions;

    try {
      dispatch(setIsLoading(true));
      const generatedSection =
        await aiHtmlPromptApi.generateAiHtmlSection(params);
      dispatch(setGeneratedSection(generatedSection));
    } catch (error) {
      dispatch(setGeneratedSection(null));
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  return {
    getAiHtmlSectionStateProps: () => {
      const { aiHtmlSection } = getState();
      const { isLoading, generatedSection } = aiHtmlSection;

      return {
        isLoading,
        generatedSection,
      };
    },
    getAiHtmlSectionDispatchProps: () => ({
      handleAiHtmlFormSubmit,
    }),
  };
}
